export const persistedStateStorageKey = 'persisted-state'

export const defaultIsDarkMode = false as boolean
